<div class="flex flex-col items-center gap-6 p-20">
  <div class="flex min-w-[600px] flex-col items-center">
    <img
      alt="403 Forbidden Image"
      [src]="'/assets/images/403-forbidden.png'"
    />
  </div>
  <span class="text-xl">Схоже, що у Вас немає доступу до цього функціоналу...</span>
  <span>Перевірте наявність відповідних доступів у свого користувача або зверніться до адміністратора</span>
</div>
